package ru.dinarastepina.fabvocab.web

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.KobwebComposeStyles
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.App
import com.varabyte.kobweb.core.KobwebApp
import com.varabyte.kobweb.silk.SilkFoundationStyles
import com.varabyte.kobweb.silk.init.initSilkWidgets
import com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb
import org.jetbrains.compose.web.css.px
import ru.dinarastepina.fabvocab.web.theme.Slate50

@App
@Composable
fun AppEntry(content: @Composable () -> Unit) {
    KobwebApp {
        KobwebComposeStyles()
        SilkFoundationStyles { ctx ->
            initSilkWidgets(ctx)
            initSilkWidgetsKobweb(ctx)
        }
        Box(
            modifier = Modifier
                .fillMaxSize()
                .backgroundColor(Slate50),
            contentAlignment = Alignment.TopCenter,
        ) {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .maxWidth(640.px)
                    .padding(16.px),
            ) {
                content()
            }
        }
    }
}
